import { render, staticRenderFns } from "./EditUserTable.vue?vue&type=template&id=b4913fb6&"
import script from "./EditUserTable.vue?vue&type=script&lang=js&"
export * from "./EditUserTable.vue?vue&type=script&lang=js&"
import style0 from "./EditUserTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports